var _defs, _sodipodiNamedview, _linearGradient;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConvertLogisticsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 1200,
    viewBox: "0 0 150 200",
    width: 1200,
    id: "svg172",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs176"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview174",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    showgrid: "false"
  }, /*#__PURE__*/React.createElement("inkscapeGrid", {
    type: "xygrid",
    id: "grid336",
    originx: -30.282262,
    originy: -6.7175142
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 112.28253,
    x2: 1613.1855,
    y1: -768.07141,
    y2: 732.8316,
    gradientTransform: "matrix(0.12073254,0,0,-0.09176326,-29.160071,98.383143)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#339cf8",
    id: "stop163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00f2fe",
    id: "stop165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03fef8",
    id: "stop167"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m 117.5439,34.647718 c 4.31173,3.265782 6.83567,8.21713 6.83567,13.48452 0,1.896261 -4.20656,27.285083 -9.35961,56.361072 -6.41501,36.23965 -9.99059,53.93808 -11.35772,56.36108 -1.15681,1.79091 -3.891081,4.4246 -6.204691,5.68878 -11.46289,6.53156 -25.554881,-1.47487 -25.765209,-14.64335 -0.105164,-6.11017 17.772739,-107.981494 19.560529,-111.457972 1.78779,-3.37113 5.5737,-6.952956 8.938951,-8.322477 4.73239,-2.001609 13.04035,-0.842783 17.35208,2.528347 z M 65.59282,51.608716 c 3.785909,1.89626 6.940833,6.110173 8.413131,11.06152 1.051642,3.37113 0.420657,8.427825 -4.732386,38.030554 -6.625341,37.29312 -7.151162,39.50543 -10.200922,43.50864 -6.62534,8.32248 -21.032828,8.00644 -27.44784,-0.63208 -3.891073,-5.16205 -3.996237,-9.27061 -0.736149,-28.6546 C 37.198502,77.629625 40.353426,61.195366 41.72056,58.456323 46.03229,50.133846 56.759032,46.973412 65.59282,51.608716 Z M 15.850182,67.516235 c 6.520177,3.055087 9.990593,11.06152 8.623459,19.910736 -3.260088,19.805389 -6.730505,36.134299 -8.307967,38.873339 -6.3098475,10.95617 -24.3980805,10.53478 -30.182109,-0.73744 -0.946477,-1.79091 -1.682626,-5.37273 -1.577462,-8.11177 0,-7.90109 6.0995205,-39.821475 8.2028045,-43.508649 4.83755,-8.322477 13.671338,-10.745476 23.2412745,-6.426216 z M 157.19078,67.410887 c 4.73239,2.423 8.41314,9.059912 8.41314,14.854041 0,7.058304 -6.09953,39.505432 -7.99248,43.297942 -2.10328,4.10857 -6.20468,7.269 -11.25256,8.84922 -8.30797,2.423 -18.29856,-3.47648 -20.92767,-12.53639 -1.1568,-3.68717 -0.84131,-6.63691 1.99812,-23.071165 4.1014,-23.071171 4.52206,-24.54604 8.83379,-28.549257 5.67886,-5.478086 13.67134,-6.531564 20.92766,-2.844391 z",
    fill: "url(#a)",
    id: "path170",
    style: {
      fill: "url(#a)",
      strokeWidth: 0.105256
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertLogisticsLogo);
export default __webpack_public_path__ + "static/media/convert-logistics-logo.caf9b1d63824ce34b281f275cd4c3067.svg";
export { ForwardRef as ReactComponent };